export default __webpack_public_path__ + "static/media/professionalism.2c32a507.webp";